import { FunctionComponent } from 'react';
import { useRoutes } from 'react-router-dom';

import { AdminRoutes, LoginRoutes, PublicRoutes } from './routes';

export const FullRoutes = [PublicRoutes, LoginRoutes, AdminRoutes];

export const Routes: FunctionComponent = () => {
  const element = useRoutes(FullRoutes);

  return element;
};
